module.exports = __webpack_public_path__ + "Server-Healthy-AzureWebApp.5a695f5c96c349664513cf8c6da04952.hashedasset.svg";